import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Waitlist from "./pages/Website/Waitlist/Waitlist";
import PrivacyPolicy from "./pages/Website/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./pages/Website/TermsConditions/TermsConditions";

// admin.taximo.ca serves the company/admin panel; every other host keeps
// the public marketing site. Both are the same static build (one S3
// origin/CloudFront distribution), so the split happens at render time.
// AdminApp is lazy-loaded so marketing/waitlist visitors never download its
// (much larger) bundle.
const AdminApp = lazy(() => import("./AdminApp"));

const isAdminHost = window.location.hostname.startsWith("admin.");

const MarketingApp = () => (
  <Routes>
    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    <Route path="/terms-and-conditions" element={<TermsConditions />} />
    <Route path="*" element={<Waitlist />} />
  </Routes>
);

const App = () => {
  if (isAdminHost) {
    return (
      <Suspense fallback={null}>
        <AdminApp />
      </Suspense>
    );
  }
  return <MarketingApp />;
};

export default App;
